import axios from "axios";

const urls = process.env.ALLOWED_HOSTS ? JSON.parse(process.env.ALLOWED_HOSTS) : [];
const deployURL = urls[0];

// Function to get CSRF token from cookies
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const axiosConfig = {
    baseURL: deployURL,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    withCredentials: true
}

const instance = axios.create(axiosConfig);

// Add CSRF token to all requests
instance.interceptors.request.use(
    config => {
        const csrftoken = getCookie('csrftoken');
        if (csrftoken) {
            config.headers['X-CSRFToken'] = csrftoken;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default instance;

